import { CircularProgress, Grid } from "@mui/material";
import React from "react";
import { useNativeWebViewInsets } from "src/context/NativeWebViewInsetsContext";
import Logo from "src/theme/Logo";
import { nativeInsetSx } from "src/utils/nativeWebViewInsets";

interface SplashScreenProps {
  loading?: string;
}

const SplashScreen: React.FC<SplashScreenProps> = ({ loading = undefined }) => {
  const nativeInsets = useNativeWebViewInsets();

  return (
    <Grid
      id={"SplashScreen"}
      container
      direction={"column"}
      gap={4}
      justifyContent={"space-around"}
      sx={{
        textAlign: "center",
        height: "100vh",
        maxWidth: 400,
        margin: "0 auto",
        ...nativeInsetSx(nativeInsets, "vertical"),
      }}
    >
      <Grid item>{loading}</Grid>
      <Grid item>
        <Logo height={300} />
      </Grid>
      <Grid item>
        <CircularProgress style={{ marginTop: 50, marginBottom: 50 }} />
      </Grid>
    </Grid>
  );
};

export default SplashScreen;
